import React from "react";

export default function FormSection({ title, children, classname }) {
  return (
    <div className={classname}>
      <h6 className="mb-3 border-b pb-1">{title}</h6>
      {children}
    </div>
  );
}
